export type TransactionCategoryIconKey =
  | "income"
  | "transfer"
  | "tax"
  | "insurance"
  | "housing"
  | "food"
  | "transport"
  | "health"
  | "utilities"
  | "education"
  | "shopping"
  | "entertainment"
  | "finance"
  | "lifestyle"
  | "category";

const normalizeCategory = (value?: string | null) =>
  String(value || "")
    .trim()
    .toLowerCase();

const matchesAny = (value: string, patterns: RegExp[]) =>
  patterns.some((pattern) => pattern.test(value));

export const getTransactionCategoryIconKey = (
  category?: string | null
): TransactionCategoryIconKey | null => {
  const normalized = normalizeCategory(category);
  if (!normalized) return null;

  if (matchesAny(normalized, [/income/, /salary/, /payroll/, /deposit/])) {
    return "income";
  }
  if (matchesAny(normalized, [/transfer/])) {
    return "transfer";
  }
  if (matchesAny(normalized, [/tax/])) {
    return "tax";
  }
  if (matchesAny(normalized, [/insurance/])) {
    return "insurance";
  }
  if (
    matchesAny(normalized, [/mortgage/, /rent/, /housing/, /home/, /property/])
  ) {
    return "housing";
  }
  if (
    matchesAny(normalized, [/food/, /grocer/, /restaurant/, /coffee/, /drink/])
  ) {
    return "food";
  }
  if (
    matchesAny(normalized, [
      /transport/,
      /rideshare/,
      /taxi/,
      /airline/,
      /hotel/,
      /travel/,
      /gas/,
      /fuel/,
      /parking/,
      /auto/,
      /car/,
      /dmv/,
    ])
  ) {
    return "transport";
  }
  if (
    matchesAny(normalized, [
      /health/,
      /medical/,
      /dental/,
      /vision/,
      /mental/,
      /pharmacy/,
    ])
  ) {
    return "health";
  }
  if (
    matchesAny(normalized, [
      /utilit/,
      /internet/,
      /mobile/,
      /phone/,
      /cable/,
      /water/,
      /electric/,
      /trash/,
    ])
  ) {
    return "utilities";
  }
  if (matchesAny(normalized, [/education/, /book/])) {
    return "education";
  }
  if (
    matchesAny(normalized, [
      /shopping/,
      /clothing/,
      /department/,
      /retail/,
      /furniture/,
      /beauty/,
      /jewelry/,
    ])
  ) {
    return "shopping";
  }
  if (
    matchesAny(normalized, [
      /entertainment/,
      /music/,
      /movie/,
      /gaming/,
      /app/,
      /sports/,
      /recreation/,
      /hobbies/,
      /streaming/,
    ])
  ) {
    return "entertainment";
  }
  if (
    matchesAny(normalized, [
      /bank/,
      /loan/,
      /credit/,
      /accounting/,
      /investment/,
      /fee/,
      /legal/,
    ])
  ) {
    return "finance";
  }
  if (
    matchesAny(normalized, [
      /childcare/,
      /family/,
      /charity/,
      /community/,
      /religious/,
      /gift/,
      /pet/,
      /personal/,
      /spa/,
      /vacation/,
    ])
  ) {
    return "lifestyle";
  }

  return "category";
};
